import { getData } from '../get-table'
import { HttpService } from '../http.service'
import { Template } from './types'
export * from './types'

const http = new HttpService()

export async function getTemplates(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['receipt_templates.country_id=:countryId']
  if (search) {
    where.push(
      `CONCAT(companies.name, payrolls.name, processes.name, receipt_templates.code, receipt_templates.name) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          'group by receipt_templates.id,receipt_templates.code,receipt_templates.name,receipt_templates.is_standard,receipt_templates.is_inactive,receipt_templates.updated_at',
          `ORDER BY (CASE WHEN receipt_templates.code ~ '^[0-9]+$' THEN CAST(receipt_templates.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, receipt_templates.code ${dataOrder[0]}`
        ])
      : (modifier = [
          'group by receipt_templates.id,receipt_templates.code,receipt_templates.name,receipt_templates.is_standard,receipt_templates.is_inactive,receipt_templates.updated_at',
          `order by ${dataOrder[1]} ${dataOrder[0]}`
        ])
    : (modifier = [
        'group by receipt_templates.id,receipt_templates.code,receipt_templates.name,receipt_templates.is_standard,receipt_templates.is_inactive,receipt_templates.updated_at',
        "ORDER BY (CASE WHEN receipt_templates.code ~ '^[0-9]+$' THEN CAST(receipt_templates.code AS NUMERIC) ELSE NULL END), receipt_templates.code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_receipt_templates'],
    fields: [
      'receipt_templates.id',
      'receipt_templates.code',
      'receipt_templates.name',
      "string_agg(distinct companies.name,', ') as companies",
      "string_agg(distinct payrolls.name,', ') as payrolls",
      "string_agg(distinct processes.name,', ') as processes",
      'receipt_templates.is_standard',
      'receipt_templates.is_inactive',
      'receipt_templates.updated_at'
    ],
    join: [
      'LEFT JOIN LATERAL jsonb_array_elements_text(receipt_templates.companies) c(company) ON TRUE',
      'LEFT JOIN companies ON companies.id = c.company::uuid',
      'LEFT JOIN LATERAL jsonb_array_elements_text(receipt_templates.payrolls) p(payroll) ON TRUE',
      'LEFT JOIN payrolls ON payrolls.id = p.payroll::uuid',
      'LEFT JOIN LATERAL jsonb_array_elements_text(receipt_templates.process) pr(process) ON TRUE',
      'LEFT JOIN processes ON processes.id = pr.process::uuid'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getTemplate(id: string): Promise<any> {
  // where's
  const where = [`receipt_templates.id='${id}'`]

  // result
  const response: any = await getData({
    tables: ['pg_receipt_templates'],
    fields: [
      'code',
      'name',
      'companies',
      'payrolls',
      'process',
      'is_standard as isStandard',
      'print_config as printConfig',
      "coalesce(header_template,'') as headerTemplate",
      'body_template as bodyTemplate',
      "coalesce(footer_template,'') as footerTemplate"
    ],

    where,
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results[0]
}

export async function getCompanies(): Promise<any> {
  const data = await getData<any>({
    tables: ['pg_companies'],

    fields: ['name', 'id'],
    where: ['country_id=:countryId'],
    options: {
      outputFormat: 'json'
    }
  })
  return data[0].results
}

export async function getPayrolls(idCompany: string): Promise<any> {
  if (idCompany === '') return
  const data = await getData<any>({
    tables: ['pg_payrolls'],

    fields: ['name', 'id'],
    where: [`company_id in (${idCompany})`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results
}

export async function getProcesses(): Promise<any> {
  const response = await getData<any>({
    tables: ['pg_processes'],
    fields: ['processes.id', 'processes.name'],
    join: [
      'INNER JOIN LATERAL jsonb_array_elements_text(processes.countries) c(country) ON TRUE',
      'INNER JOIN countries ON countries.id = c.country::uuid'
    ],
    where: ['countries.id in (:countryId)']
  })

  return response[0].results
}

export async function createTemplate(data: Template): Promise<boolean> {
  const response: any = await http.post('reports/receipt-template', {
    code: data.code,
    name: data.name,
    isStandard: data.isStandard,
    companies: data.companies,
    payrolls: data.payrolls,
    process: data.process,
    bodyTemplate: data.bodyTemplate,
    headerTemplate: data.headerTemplate,
    footerTemplate: data.footerTemplate,
    printConfig: data.printConfig
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function copyTemplate(id: string): Promise<boolean> {
  const response: any = await http.post(
    `reports/receipt-template/copy/${id}`,
    {}
  )

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateTemplate(
  data: Template,
  id: string
): Promise<boolean> {
  const response: any = await http.put('reports/receipt-template/' + id, {
    code: data.code,
    name: data.name,
    isStandard: data.isStandard,
    companies: data.companies,
    payrolls: data.payrolls,
    process: data.process,
    bodyTemplate: data.bodyTemplate,
    headerTemplate: data.headerTemplate,
    footerTemplate: data.footerTemplate,
    printConfig: data.printConfig
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateStateTemplate(
  id: string,
  enable: boolean
): Promise<boolean> {
  const response: any = await http.put(
    `reports/receipt-template/${id}/enable/`,
    {
      enable
    }
  )

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteTemplate(id: string): Promise<boolean> {
  const response: any = await http.delete('reports/receipt-template/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function getParamsTemplate(): Promise<any> {
  const response: any = await http.get('/reports/receipt-template/parameters')

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }

  return response?.data
}
